import React, { Component } from 'react';
import styled from 'styled-components';
import TextContent from './TextContent';
import ImageContent from './ImageContent';

const Container = styled.div`
    display: flex;
    flex-flow: row nowrap;
    /* border: 1px dashed red; */
`;

class Work extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vh: 0,
      slideNumber: 0,
    };
    this.pageSplitTimes = 1.4;
    this.lastScrollTop = 0;
    this.scrollDirectionDown = true;
    this.handleScroll = this.handleScroll.bind(this);
    this.workDetails = [
      {
        number: '',
        projectName: '',
        projectDesc: '',
        projectType: '',
        roles: [''],
      },
      {
        number: '01',
        projectName: 'Wisma Kagama',
        projectDesc: 'A web-based application for hotel room reservation at Wisma Kagama hotel.',
        projectType: 'WEB APP',
        roles: ['Full-stack Developer'],
      },
      {
        number: '02',
        projectName: 'Thfool',
        projectDesc: 'A web-based application with news and information about Genshin Impact, as well as recharge and account booster services.',
        projectType: 'WEB APP',
        roles: ['Full-stack Developer'],
      },
      {
        number: '03',
        projectName: 'Automotive News',
        projectDesc: 'A web-based application that contains the latest news and information about the automotive world.',
        projectType: 'WEB APP',
        roles: ['Front-end Developer'],
      },
      {
        number: '04',
        projectName: 'e-Library',
        projectDesc: 'A web-based application for borrowing library books.',
        projectType: 'WEB APP',
        roles: ['Full-stack Developer'],
      },
      {
        number: '05',
        projectName: 'Movie Catalogue',
        projectDesc: 'A mobile-based application that contains information about the latest movies and tv series that are currently airing.',
        projectType: 'ANDROID APP',
        roles: ['Full-stack Developer'],
      },
      {
        number: '06',
        projectName: 'd\'Laundry',
        projectDesc: 'A mobile-based application about laundry shuttle service.',
        projectType: 'ANDROID & iOS APP',
        roles: ['UI Designer'],
      },
      {
        number: '',
        projectName: '',
        projectDesc: '',
        projectType: '',
        roles: [''],
      },
    ];
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.setState(
      {
        vh: Math.round(
          window.document.documentElement.clientHeight * this.pageSplitTimes,
        ),
      },
    );
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {
    const { body, documentElement } = event.srcElement;
    const { vh, slideNumber } = this.state;
    const scrollDistance = Math.max(body.scrollTop, documentElement.scrollTop);
    if (scrollDistance > this.lastScrollTop) {
      this.scrollDirectionDown = true;
    } else {
      this.scrollDirectionDown = false;
    }
    this.lastScrollTop = scrollDistance;
    // console.log(scrollDistance);

    if (Math.floor(scrollDistance / vh) !== slideNumber
      && slideNumber < this.workDetails.length - 1) {
      this.setState({ slideNumber: Math.floor(scrollDistance / vh) });
    } else if (slideNumber === this.workDetails.length - 1
      && (Math.floor(scrollDistance / vh) < slideNumber)) {
      this.setState({ slideNumber: Math.floor(scrollDistance / vh) });
    }
  }

  changeTextContentBasedOnScroll() {
    const { slideNumber } = this.state;
    const refresh = true;
    return (
      <TextContent
        number={this.workDetails[slideNumber].number}
        projectName={this.workDetails[slideNumber].projectName}
        projectDesc={this.workDetails[slideNumber].projectDesc}
        projectType={this.workDetails[slideNumber].projectType}
        roles={this.workDetails[slideNumber].roles}
        refreshToggle={refresh}
      />
    );
  }

  render() {
    return (
      <Container>
        {this.changeTextContentBasedOnScroll()}
        <ImageContent pageSplitTimes={this.pageSplitTimes} />
      </Container>
    );
  }
}

export default Work;
